import { Component, computed, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { EmployerDetails } from '../../data/employer-details';
import { AssessmentService } from '../../services/assessment.service';
import { IFormComponent } from '../../models/i-form-component';
import { AbnValidators } from '../../validators/abn-validatiors';
import { OptionItem } from '../../data/option-item';

@Component({
  selector: 'app-employer-details',
  templateUrl: './employer-details.component.html',
  styleUrl: './employer-details.component.scss'
})
export class EmployerDetailsComponent implements OnInit, IFormComponent {
  
  assessmentService = inject(AssessmentService);
  formBuilder = inject(NonNullableFormBuilder);

  @Input()model!: InitialAssessmentForm;
  @Input()phoneTypes!: OptionItem[];
  @Output() formReady = new EventEmitter<FormGroup>();

  employerForm = this.formBuilder.group({
        hasOffer: ['', [Validators.required]],
        name: [''],
        abn: ['', [AbnValidators.maxLength()]],
        firstName: [''],
        surname: [''],
        email: ['', [Validators.email]],
        phoneType: [null as OptionItem | null],
        phoneCountryCode: [''],
        phoneAreaCode: [''],
        phoneNumber: [''],
        jobTitle: [''],
        salary: ['', [Validators.min(0)]],
        canContact: ['']
      });
      
  ngOnInit(): void {    

    this.handleFormModelBinding();

    this.formReady.emit(this.employerForm);
  }

  handleFormModelBinding() {
    
    this.model = this.model || new InitialAssessmentForm();
    this.model.employer = this.model.employer || new EmployerDetails();
    
    // Bind form to model data
    this.employerForm?.patchValue(this.model.employer);   
    
    // Subscribe to form changes to update model
    this.employerForm?.valueChanges.subscribe(value => {
      this.model.employer = {
        ...this.model.employer!,
        ...value
      }
    });
  }

  // Might be worth moving to a pipe if used elsewhere
  // Its being called frequently due to Angular change detection
  personTerm(suffix: string = '') : string {
    const term = 
      this.assessmentService.isVevoEmployee()
      ? 'Contact Person'
      : 'Employer Contact Person';
    return suffix ? `${term} ${suffix}` : term;    
  }

  hasOfferLabel = computed(() =>{
    if(this.assessmentService.isVevoMyself())
      return 'Do you have a job offer or are you employed by an Australian Business or Organisation?';
    if(this.assessmentService.isVevoEmployee())
      return 'Is this person employed or potentially employed by an Australian Business or Organisation?';
    if(!this.assessmentService.isVevo())
      return 'Do you have a job offer from an Australian business or organisation?';
    
    // This should never occur, but silently fallback just in case
    return 'Do you have a job offer from an Australian business or organisation?';
  });



  isFormValid(): boolean {
    return this.employerForm.valid;
  }

  markFormAsTouched(): void {
    this.employerForm.markAllAsTouched();
  }

}